import ColorCodedDate from 'models/common/ColorCodedDate';

import { sendAnsweredSurveyQuestionEvent } from 'constants/mixpanelHelper';

import { getSurveyDetails, updateSurvey } from 'services/engagement';
import { getTemplateStructure } from 'services/templates/engagement';

import { pulseSurveyInitialState } from './pulseSurveyReducer';

export const ADD_SURVEY_DETAILS = 'ADD_SURVEY_DETAILS';
export const UPDATE_ANSWER = 'UPDATE_ANSWER';
export const MOVE_TO_QUESTION = 'MOVE_TO_QUESTION';
export const MOVE_TO_NEXT_QUESTION = 'MOVE_TO_NEXT_QUESTION';
export const MOVE_TO_PREVIOUS_QUESTION = 'MOVE_TO_PREVIOUS_QUESTION';
// to show quick response to user when updating responses, but reset state in case the update request fails.
export const RESET_STATE = 'RESET_STATE';

export function addSurveyDetailsAction(surveyId) {
  return (dispatch) =>
    getSurveyDetails({ surveyId }).then((data) => {
      dispatch({ type: ADD_SURVEY_DETAILS, data });
    });
}

export function addPreviewSurveyDetailsAction(templateId, props = {}) {
  return (dispatch) =>
    getTemplateStructure({ templateId }).then(({ templateQuestions }) => {
      const data = {
        ...pulseSurveyInitialState,
        name: 'Template Preview',
        endDateFormatted: ColorCodedDate.fromJSON({
          timeStamp: Date.now(),
          color: 'BLUE',
          reason: null,
          isCrossed: false,
        }),
        questions: templateQuestions,
        ...props,
      };
      dispatch({ type: ADD_SURVEY_DETAILS, data });
    });
}

export function updateAnswerAction({ surveyId, questionId, answerId, feedbackText, isPreview }) {
  return (dispatch, getState) => {
    // optimistically updates the UI to reduce update duration in UI
    dispatch({ type: UPDATE_ANSWER, data: { questionId, answerId, feedbackText } });

    // In case of Preview, we just update the local state and return.
    if (isPreview) return;

    return updateSurvey({
      surveyId,
      surveyQuestionId: questionId,
      selectedOptionId: answerId,
      feedbackText,
    })
      .then((data) => {
        sendAnsweredSurveyQuestionEvent({
          eventProperties: {
            surveyId,
            questionId,
            answerOptionId: answerId,
            feedbackText: !!feedbackText,
          },
        });
        const state = getState();
        const questionData = state.questionsData.filter((item) => item.id === questionId)[0];
        // get previously selected answer for current question
        const { enableFeedbackText } = questionData;
        let goToNextQuestion = false;
        // check if question also has a comment box
        // check if all input fields shown have responses
        if (answerId !== null && (enableFeedbackText ? feedbackText !== null : true)) {
          goToNextQuestion = true;
        }

        if (goToNextQuestion) {
          // disabling this for now.
          // setTimeout(() => dispatch(moveToNextQuestionAction()), 500);
        }
      })
      .catch((e) => {
        // show network issue message
        // this get state will return previous state, the one before the UPDATE_ANSWER dispatch
        dispatch({ type: RESET_STATE, data: getState() });
      });
  };
}

export function moveToNextQuestionAction() {
  return { type: MOVE_TO_NEXT_QUESTION };
}

export function moveToPreviousQuestionAction() {
  return { type: MOVE_TO_PREVIOUS_QUESTION };
}

export function moveToQuestion(questionId) {
  return { type: MOVE_TO_QUESTION, data: { questionId } };
}
